import { LocaleOption } from "@/dto/localeOption";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

export interface SelectedCountryCodeProps {
  currentLocaleOption: LocaleOption;
  open: boolean;
  optionSize: number;
}

export const SelectedCountryCode = ({
  currentLocaleOption,
  open,
  optionSize,
}: SelectedCountryCodeProps) => {
  const CountryFlag = () => currentLocaleOption.flag;
  return (
    <div className="flex flex-col gap-[2px] border border-[#727272] rounded px-2 items-start max-h-[53px] min-w-[95px] w-[120px] pt-1 pb-[6px]">
      <p className="text-xs text-[#727272] whitespace-nowrap">Country Code</p>
      <div className="flex gap-1">
        <CountryFlag />
        <span className="text-base pr-5">
          {currentLocaleOption.countryCode}
        </span>
        {optionSize > 1 && (
          <ChevronDownIcon
            height={20}
            width={20}
            className={open ? "rotate-180 transform" : ""}
          />
        )}
      </div>
    </div>
  );
};
